/**
 * A collection of well known communication preference types used by the api.
 */
const COMMUNICATION_PREF_TYPES = {
  Email: 'email',
};

export default COMMUNICATION_PREF_TYPES;
